import { Log } from 'ng2-logger';
import ApiClient from './alms-api';
import Translator from '../core/i18n';

const _logger = Log.create('Gradebook-Service');
const T = Translator.create();
const token: any = localStorage.getItem('access_token');
let _apiClient: ApiClient;

export class GradebookService {

    constructor() {
        _apiClient = new ApiClient();
    }

    public async RequestGetMyGradeBookAsync() {
        return _apiClient.RequestAsync('GET', 'api/gradebook/mygradebook', null, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }
}

